<template>
    <v-container>
        <v-row>
            <v-col
                class="text-center mt-4 pa-0"
            >
                <h1>
                    Ingredients
                </h1>
            </v-col>
        </v-row>
        <v-row
            v-if="adminView"
            no-gutters
        >
            <Ingredients/>
        </v-row>
    </v-container>
</template>

<script>
// @ is an alias to /src
import Ingredients from '@/components/menu/Ingredients.vue'

export default {
  components: {
    Ingredients
  },

  data: () => ({

  }),

  computed: {
    adminView() {
        return this.$store.getters['data/adminView'];
    },
  }

}
</script>
